import { Image as ImageComponent } from '@nfinite/react-hubstairs/components'
import config from 'utils/config'

const IS_PRODUCTION = config.get('ENVIRONMENT') === 'production'

function Image({ src, picture, fallback, sizes, alt = '', fit = 'contain', onLoad, loading, className, quality }) {
  return (
    <ImageComponent
      src={src}
      picture={picture}
      fallback={fallback}
      sizes={sizes}
      alt={alt}
      fit={fit}
      onLoad={onLoad}
      loading={loading}
      className={className}
      skipValidation={IS_PRODUCTION}
      autoSizes
      quality={quality}
    />
  )
}

export const TODO_TypeImagePicture = null
export const TODO_TypeImage = null

export default Image
